import { tss } from 'tss-react/mui';

export const useFooterStyles = tss.withName('FooterSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(6, '6%'),
    },
    row: {
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        paddingTop: theme.spacing(4),
        borderTop: `1px solid ${theme.palette.divider}`,
    },
    logo: {
        fontWeight: 600,
        letterSpacing: '-0.01em',
    },
    links: {
        display: 'flex',
        gap: theme.spacing(3),
    },
    link: {
        color: 'inherit',
        textDecoration: 'none',
        fontSize: '0.85rem',
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    legalRow: {
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginTop: theme.spacing(3),
    },
}));
